import LegalDocumentVersionPage from '@pages/settings/legal-documents/LegalDocumentVersionPage'
import { Navigate, RouteObject } from 'react-router-dom'

const LegalDocumenDetailRoutes: RouteObject[] = [
  {
    path: ':version?',
    element: <LegalDocumentVersionPage />,
  },
  {
    path: '*',
    element: <Navigate to="/404" replace />,
  },
]

export default LegalDocumenDetailRoutes
